// import { useEffect, useState } from "react";

import React, { useState } from "react";
import { Header } from "../../components/Header";
import WhatsappButton from "../../components/WhatsappButton";
import {
  MainContainer,
  Content,
  TitleContainer,
  InfoContainer,
  LoginContainer,
  RowItems,
  ButtonsContainer,
  Button,
  TextImageContainer,
  InfoTicoopContainer,
  TextContainer,
  ImageContainer,
} from "./styled";
import { DefaultLogin } from "../../components/DefaultLogin";
import { useSearchParams } from "react-router-dom";
import { OportunityLoginIndex } from "../../components/OportunityLoginIndex";

const Index = () => {
  const [searchParams] = useSearchParams();
  const oportunity = searchParams.get("oportunidade");

  const [loginOnScreen, setLoginOnScreen] = useState(false);

  return (
    <Content>
      <WhatsappButton />
      <Header />
      <MainContainer>
        <TitleContainer>
          <span>{"Bem-vindo(a) à TICOOP BRASIL!"}</span>
        </TitleContainer>
        <InfoContainer>
          <TextImageContainer>
            <ImageContainer>
              <img
                src="https://ticoopbrasil.coop.br/wp-content/uploads/2023/03/CONHECA-A-TICOOP-BRASIL.png.webp"
                alt="Homem mechendo em um notebook com um monitor com código atrás com a logo da TICOOP atrás"
              />
            </ImageContainer>
            <TextContainer>
              <p>
                Aqui você poderá cadastrar suas{" "}
                <strong>
                  informações pessoais, experiências profissionais, formações
                  acadêmicas
                </strong>{" "}
                e <strong>principais tecnologias que domina</strong> de forma
                simples e segura. Manter seu perfil atualizado é o primeiro
                passo para aproveitar as oportunidades de trabalho e
                desenvolvimento oferecidas pela nossa cooperativa.
              </p>
            </TextContainer>
          </TextImageContainer>
          {loginOnScreen &&
            (oportunity ? (
              <OportunityLoginIndex oportunity={oportunity} />
            ) : (
              <DefaultLogin />
            ))}
          <InfoTicoopContainer>
            <p>
              <strong>
                Na TICOOP BRASIL, acreditamos no poder da colaboração e no
                potencial de cada profissional.
              </strong>{" "}
              Ao fazer parte da nossa rede, você se conecta com projetos, amplia
              sua visibilidade e fortalece sua trajetória no mercado.
            </p>
          </InfoTicoopContainer>
        </InfoContainer>
        {!loginOnScreen && (
          <LoginContainer>
            <RowItems>
              <span>Faça seu login para visualizar esse conteúdo</span>
              <ButtonsContainer>
                <Button onClick={() => setLoginOnScreen(true)}>Login</Button>
                <a href="/cadastro">
                  <Button>Cadastre-se</Button>
                </a>
              </ButtonsContainer>
            </RowItems>
          </LoginContainer>
        )}
      </MainContainer>
    </Content>
  );
};

export default Index;
